export const config = {
  CompanyName: 'Plus Network',
  ApiResultsPerPage: 50,
  Headline: 'Plus Network helps attract talent to the companies around the world.',
  Motto: 'Start applying for the thousands of jobs available',
};
